import AuditLogs from './audit-logs';

export default AuditLogs;
